const ACTION_EXTEND = 'extend';
const ACTION_CHANGE = 'change';

const ACTIONS = [
    ACTION_EXTEND,
    ACTION_CHANGE,
];

export {
    ACTION_EXTEND,
    ACTION_CHANGE,
    ACTIONS,
};
